var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "admin layout is-flex" }, [
    _c(
      "div",
      {
        ref: "appMenuContainer",
        staticClass: "is-hidden-touch",
        attrs: { id: "appMenuContainer" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "logo-container is-flex is-centered is-flex-direction-column"
          },
          [
            _c("img", {
              staticClass: "logo",
              attrs: { src: _vm.$store.state.ui.logo, alt: "company logo" }
            }),
            _c(
              "h1",
              { staticClass: "title is-4 has-text-izzi-robins-egg-blue" },
              [_vm._v("\n        factura electrónica\n      ")]
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "menu-container" },
          [_c("AppMenu", { staticClass: "sidebar navbar" })],
          1
        ),
        _c("div", { staticClass: "separator" }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false"
              }
            ],
            staticClass: "notifications"
          },
          [_c("AppButtonAddCiec"), _c("AppButtonVerificationPending")],
          1
        )
      ]
    ),
    _c(
      "div",
      { staticClass: "is-flex main-container" },
      [_c("TheNavbar"), _c("main", [_c("RouterView")], 1)],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }